import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { getProps } from '../math-topics'

export const getStaticProps = getStaticPropsWrapper(getProps, { campaign: true, path: '/math-topics' })

export { default } from '../math-topics'
